import './LessonActionBar.css';
import PopupQuestion from '../../../progressbar/PopupQuestion';

const INFORMATIVE_TYPES = [
  'JustInTimeMotivation',
  'serieCompleta',
  'deblocarePremium',
  'clasament',
];

const TYPES_WITHOUT_HELP = [
  'explanationLesson',
  'formulaExplanationLesson',
  'feedbackLesson',
  'lessonCompletion',
  'lessonResume',
  'JustInTimeMotivation',
  'serieCompleta',
  'deblocarePremium',
  'clasament',
];

const LessonActionBar = ({
  // Afisare generala
  show = true,
  hidden = false,

  // Intrebarea curenta
  currentQuestion,
  lessonData,

  // Text si stare buton
  textButton,
  desableButon,
  changeColorButton,

  // Stari lectie
  isLessonFinished,
  finalMessage,
  isLessonCompletionBarDone,
  isWaitingTopProgress,

  // Stari quiz
  isAnswerChecked,
  showCorrectAnswer,
  simpleCorrectAnswer,

  // Explanation lesson
  isExplanationCardLesson,
  isExplanationContinueLocked,
  totalCards,
  cardIndex,

  // Decision flow
  decisionPhase,
  decisionStepIndex,

  // Recompense lectie
  lessonXp,
  lessonCoins,

  // Date HELP
  coinCount = 0,
  quizExplanation,
  onRevealAnswer,
  onSpendCoins,

  // Referinta completion
  lessonCompletionSentRef,

  // Imagini
  changeCardImage,
  contextImage,

  // Functii generale
  verifyAnswer,
  toNextQuestion,
  finalizeLesson,

  // Functii completion
  sendLessonCompletion,
  sendLessonFinishXp,
  addCoins,
  updateDailyMissions,

  // Feedback lesson
feedbackLessonRef,
hasLessonFeedback,


  // Functii feedback
  handleHideFeedback,
  setShowFeedback,

  // Functii UI
  setHideActionButton,
  setShowPracticeHelp,
showPracticeHelp,
  // Functii card
  updateCardIndexWithSwipe,

  // Setteri decision flow
  setDecisionPhase,
  setDecisionStepIndex,
  setDecisionAnswer,
  setDecisionSelectedAnswers,
  setDecisionDragAnswer,

  // Setteri quiz
  setIsAnswerChecked,
  setAnswerStatus,
  setDesableButton,
  setTextButton,
  setChangeColorButton,
}) => {
  if (!show || !currentQuestion) {
    return null;
  }

  const isWaitingLessonCompletionBar =
    isLessonFinished &&
    currentQuestion.type === 'lessonCompletion' &&
    !isLessonCompletionBarDone;

  const isVerifyButton = textButton === 'Verifica';

  const isDecisionFlowContextMode =
  currentQuestion.type === 'decisionFlowApplication' &&
  decisionPhase === 'steps' &&
  !isAnswerChecked &&
  desableButon;


const isFeedbackDisabled =
  currentQuestion.type === 'feedbackLesson' &&
  !hasLessonFeedback;

const isPrimaryDisabled =
  isFeedbackDisabled ||
  (!isDecisionFlowContextMode && desableButon) ||
  isWaitingLessonCompletionBar ||
  (isWaitingTopProgress && !isVerifyButton);



  const explanationDescriptions = Array.isArray(
    currentQuestion.descriptionExplanation
  )
    ? currentQuestion.descriptionExplanation
    : [];

  const isSingleExplanationCard =
    explanationDescriptions.length === 1 &&
    currentQuestion.type !== 'formulaExplanationLesson';

  const showHelpButton =
    !isExplanationCardLesson &&
    !TYPES_WITHOUT_HELP.includes(currentQuestion.type);

  const helpExplanation =
    quizExplanation ||
    currentQuestion.explanation ||
    '<p>Explicatia nu este disponibila pentru acest quiz.</p>';

  const resetDecisionStepState = () => {
    setDecisionAnswer?.(null);
    setDecisionSelectedAnswers?.([]);
    setDecisionDragAnswer?.([]);
    setIsAnswerChecked?.(false);
    setAnswerStatus?.(null);
    setDesableButton?.(true);
    setTextButton?.('Verifica');
    setChangeColorButton?.(false);
  };

  const handleLessonCompletion = async () => {
    if (
      currentQuestion.type !== 'lessonCompletion' ||
      lessonCompletionSentRef?.current
    ) {
      return false;
    }

    await sendLessonCompletion?.(
      currentQuestion.type,
      lessonXp
    );

    const lessonType = String(
      lessonData?.explanationType || ''
    ).toLowerCase();

    const isApplication = lessonType === 'aplicatie';
    const isLesson = lessonType === 'lectie';

    updateDailyMissions?.({
      lesson: isLesson ? 1 : 0,
      application: isApplication ? 1 : 0,
    });

    if (lessonXp > 0) {
      await sendLessonFinishXp?.(lessonXp);
    }

    if (lessonCoins > 0) {
      await addCoins?.(lessonCoins);
    }

    if (lessonCompletionSentRef) {
      lessonCompletionSentRef.current = true;
    }

    setDesableButton?.(true);
    toNextQuestion?.();

    return true;
  };

  const handleDecisionFlowAction = () => {
    if (
      currentQuestion.type !==
      'decisionFlowApplication'
    ) {
      return false;
    }

    if (decisionPhase === 'intro') {
      setDecisionPhase?.('steps');
      setDecisionStepIndex?.(0);
      resetDecisionStepState();
      setHideActionButton?.(false);

      return true;
    }

if (decisionPhase === 'final') {
  setDecisionPhase?.('intro');
  setDecisionStepIndex?.(0);

  setDecisionAnswer?.(null);
  setDecisionSelectedAnswers?.([]);
  setDecisionDragAnswer?.([]);

  setIsAnswerChecked?.(false);
  setAnswerStatus?.(null);

  setDesableButton?.(false);
  setTextButton?.('Continua');
  setChangeColorButton?.(false);

  setShowPracticeHelp?.(false);
  setHideActionButton?.(false);

  toNextQuestion?.();

  return true;
}

    if (decisionPhase !== 'steps') {
      return true;
    }

    if (!isAnswerChecked) {
      verifyAnswer?.();
      setHideActionButton?.(true);
      setShowFeedback?.(true);

      return true;
    }

    handleHideFeedback?.();

    const steps = Array.isArray(
      currentQuestion.steps
    )
      ? currentQuestion.steps
      : [];

    const hasNextStep =
      decisionStepIndex < steps.length - 1;

    if (hasNextStep) {
      setDecisionStepIndex?.(
        (previousIndex) => previousIndex + 1
      );

      resetDecisionStepState();
    } else {
      setDecisionPhase?.('final');
      setDecisionAnswer?.(null);
      setDecisionSelectedAnswers?.([]);
      setDecisionDragAnswer?.([]);
      setIsAnswerChecked?.(false);
      setAnswerStatus?.(null);
      setDesableButton?.(false);
      setTextButton?.('Continua');
      setChangeColorButton?.(false);
    }

    setHideActionButton?.(false);

    return true;
  };

const handlePrimaryAction = async () => {
  if (
  currentQuestion.type ===
    'decisionFlowApplication' &&
  showPracticeHelp
) {
  setShowPracticeHelp?.(false);
  return;
}
  if (isDecisionFlowContextMode) {
    setShowPracticeHelp?.(true);
    return;
  }

  if (
    isWaitingTopProgress &&
    textButton !== 'Verifica'
  ) {
    return;
  }

  if (
  currentQuestion.type ===
  'feedbackLesson'
) {
  if (!hasLessonFeedback) {
    return;
  }

  const wasSubmitted =
    await feedbackLessonRef?.current?.submitFeedback?.();

  if (wasSubmitted) {
    setHideActionButton?.(false);
    toNextQuestion?.();
  }

  return;
}


    if (isLessonFinished) {
      if (isWaitingLessonCompletionBar) {
        return;
      }

      finalizeLesson?.();
      return;
    }

    if (
      INFORMATIVE_TYPES.includes(
        currentQuestion.type
      )
    ) {
      toNextQuestion?.();
      setHideActionButton?.(false);
      return;
    }

    const handledCompletion =
      await handleLessonCompletion();

    if (handledCompletion) {
      return;
    }

    const handledDecisionFlow =
      handleDecisionFlowAction();

    if (handledDecisionFlow) {
      return;
    }

    if (isAnswerChecked) {
      toNextQuestion?.();
      setHideActionButton?.(false);
      return;
    }

    verifyAnswer?.();
    setHideActionButton?.(true);
    setShowFeedback?.(true);
  };

  const handleExplanationContinue = () => {
    if (isExplanationContinueLocked) {
      return;
    }

    toNextQuestion?.();
    setHideActionButton?.(false);
  };

  const handleChangeCard = () => {
    if (
      !isExplanationCardLesson ||
      totalCards <= 1
    ) {
      return;
    }

    const targetIndex =
      (cardIndex + 1) % totalCards;

    updateCardIndexWithSwipe?.(targetIndex);
  };

const getPrimaryButtonClassName = () => {
  if (isPrimaryDisabled) {
    return 'button-next-quizbc-desabled';
  }

  if (isDecisionFlowContextMode) {
    return 'button-next-quizbc-context';
  }

  if (changeColorButton) {
    return 'button-next-quizbc-verify';
  }

  return 'button-next-quizbc';
};

  const explanationDisabledStyle =
    isExplanationContinueLocked
      ? {
          filter: 'grayscale(1)',
          background: '#d3d3d3',
          color: 'rgb(193 193 193)',
          border: '0 solid #999',
          boxShadow: '0 4px 0 #999',
          cursor: 'not-allowed',
          opacity: 1,
        }
      : undefined;

  return (
    <div
      className={[
        'position-button-lesson-bc',
        hidden ? 'hide hide-border-top' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {showCorrectAnswer && (
        <div className="answer-show-after-button">
          {isAnswerChecked
            ? simpleCorrectAnswer
            : null}
        </div>
      )}

      <div
        className={[
          'button-group-navigationbc',
          hidden ? 'hide' : '',
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <div
className={[
  'lesson-navigation-row',
  showHelpButton
    ? 'lesson-navigation-row--with-help'
    : 'lesson-navigation-row--without-help',
  (
    currentQuestion.type === 'feedbackLesson' ||
    currentQuestion.type === 'lessonCompletion'
  )
    ? 'lesson-navigation-row--center'
    : '',
]
    .filter(Boolean)
    .join(' ')}
>
          {/* HELP - deschide PopupQuestion */}
          {showHelpButton && (
            <div className="lesson-help-button-wrapper">
              <PopupQuestion
                triggerType="action"
                triggerClassName="button-help-bc"
                quizExplanation={helpExplanation}
                coinCount={coinCount}
                onRevealAnswer={onRevealAnswer}
                onSpendCoins={onSpendCoins}
              />
            </div>
          )}

          {/* Buton principal */}
          {!isExplanationCardLesson && (
            <button
              type="button"
              className={getPrimaryButtonClassName()}
              disabled={isPrimaryDisabled}
              onClick={handlePrimaryAction}
            >
              {isLessonFinished && finalMessage ? (
                'Urmatoarea lectie'
              ) : (
                <>
<span>
  {currentQuestion.type ===
    'decisionFlowApplication' &&
  decisionPhase === 'intro'
    ? 'Continua'
    : showPracticeHelp &&
        currentQuestion.type ===
          'decisionFlowApplication'
      ? 'Continua'
      : isDecisionFlowContextMode
        ? 'Vezi contextul'
        : textButton || 'Continua'}
</span>


                </>
              )}
            </button>
          )}

          {/* Continua pentru explanationLesson */}
          {isExplanationCardLesson && (
            <button
              type="button"
              className={
                isSingleExplanationCard
                  ? 'button-explanation-continue-single'
                  : 'button-explanation-continue-multi'
              }
              disabled={
                isExplanationContinueLocked
              }
              style={explanationDisabledStyle}
              onClick={handleExplanationContinue}
            >
              Continua
            </button>
          )}

          {/* Schimba cardul */}
          {isExplanationCardLesson &&
            totalCards > 1 && (
              <button
                type="button"
                className="button-next-card-bc"
                onClick={handleChangeCard}
                aria-label="Schimba cardul"
              >
                {changeCardImage && (
                  <img
                    src={changeCardImage}
                    alt="Schimba cardul"
                    className="change-card-gif-bc-explicatii"
                  />
                )}
              </button>
            )}

          {/* Context decision flow */}
        
        </div>
      </div>
    </div>
  );
};

export default LessonActionBar;